import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const typesData = [
  { id: 1, name: 'Admin Training' },
  { id: 2, name: 'Guard Training' },
];

const PostCampForm = ({
  isFiled,
  handleValue = null,
  handleDataFilter = null,
  handleremoveValue = null,
}) => {
  const objInput = { type: '', name: '', designation: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputListData3, setInputListData3] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [typeVal, setTypeVal] = useState('');
  const [nameVal, setNameVal] = useState('');
  const [desigVal, setDesigVal] = useState('');
  const inputRef = useRef([]);

  const addUser = () => {
    if (
      !String(inputListData1).length ||
      !inputListData2.length ||
      !inputListData3.length
    ) {
      setIsError(true);
      return false;
    }
    setInputValue([...inputValue, { type: '', name: '', designation: '' }]);
    if (inputListData1?.id) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
    setInputListData3('');
  };
  const removeGate = (index = null) => {
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);

    setInputValue([...inputValue]);
    setInputList([...inputList]);
    const arrLength = inputValue.length;
    setInputListData1(inputValue[arrLength - 1].type);
    setInputListData2(inputValue[arrLength - 1].name);
    setInputListData3(inputValue[arrLength - 1].designation);

    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  const handleInitalValue = () => {
    setTypeVal('');
    setNameVal('');
    setDesigVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };

  useEffect(() => {
    if (inputValue) {
      for (const key in inputValue) {
        if (inputValue[key]) {
          if (
            inputValue[key].type &&
            inputValue[key].name &&
            inputValue[key].designation
          ) {
            handleValue(inputValue);
          } else handleValue(null);
        } else handleValue(null);
      }
    } else {
      handleValue(null);
    }
  }, [inputValue]);

  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    list[index][key] = val;
    setInputValue([...list]);
  };

  return (
    <Fragment>
      <FormSection
        title={localization.postCampDetails}
        className={isFiled ? 'filled' : ''}
      >
        <div className="w-100 row mx-0">
          <div ref={inputRef.current[0]} className="row mx-0">
            <DropDownInput
              label={localization.selectCategory}
              data={typesData}
              getIdValue={(val) => {
                setTypeVal(val.id);
                setInputListData1(val.id);
                setIsCurrentRef(0);
                handleInputValue(val.id, 'type', 0);
              }}
              errorMsg={localization.isRequired}
              // value={typeVal}
              required
              isStarRequired={true}
            />

            <ConstantInput
              label={localization.name}
              errorMsg={localization.isRequired}
              type="text"
              value={nameVal}
              handleChange={(val) => {
                setNameVal(val);
                setInputListData2(val);
                setIsCurrentRef(0);
                handleInputValue(val, 'name', 0);
              }}
              required
              isStarRequired={true}
            />

            <ConstantInput
              label={localization.designation}
              errorMsg={localization.isRequired}
              type="text"
              value={desigVal}
              handleChange={(val) => {
                setDesigVal(val);
                setInputListData3(val);
                setIsCurrentRef(0);
                handleInputValue(val, 'designation', 0);
              }}
              required
              isStarRequired={true}
            />
            {inputList.length === 0 && typeVal && nameVal && desigVal && (
              <div className="form-group">
                <ButtonWithIcon
                  onClick={handleInitalValue}
                  title={localization.clear}
                />
              </div>
            )}
          </div>
        </div>

        {inputList &&
          inputList.map((item, index) => {
            return (
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={typesData}
                    getIdValue={(val) => {
                      setInputListData1(val.id);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val.id, 'type', index + 1);
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />

                  <ConstantInput
                    label={localization.name}
                    errorMsg={localization.isRequired}
                    type="text"
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'name', index + 1);
                    }}
                  />

                  <ConstantInput
                    label={localization.designation}
                    errorMsg={localization.isRequired}
                    type="text"
                    handleChange={(val) => {
                      setInputListData3(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'designation', index + 1);
                    }}
                  />
                  <div className="">
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        {isError ? (
          <div className="full-width">
            <label className="error d-block">{localization.enterField}</label>
          </div>
        ) : null}
        <div className="form-group">
          <ButtonWithIcon title={localization.addMoreGates} onClick={addUser} />
        </div>
      </FormSection>
    </Fragment>
  );
};

export default PostCampForm;
